"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _styles = require("./styles");
var _Keyboard = require("../../enums/Keyboard");
var _jsxRuntime = require("@emotion/react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/** @jsxImportSource @emotion/react */

const Card = /*#__PURE__*/_react.default.forwardRef(({
  className,
  ...props
}, ref) => {
  const handleOnKeyPress = e => {
    if (e.key === _Keyboard.Key.enter || e.key === _Keyboard.Key.space) {
      if (props.onClick) {
        props.onClick();
      }
    }
  };
  return (0, _jsxRuntime.jsx)("div", {
    ref: ref,
    css: theme => [_styles.styles.default(theme), props.shadow && _styles.styles.shadow(theme), props.withhover && _styles.styles.withHover(theme), props.primary && _styles.styles.primary(theme), props.gray && _styles.styles.gray, props.noPadding && _styles.styles.noPadding, props.height && _styles.styles.height(props.height), props.nobackground && _styles.styles.nobackground, props.largePadding && _styles.styles.largePadding, props.overflowvisible && _styles.styles.overflowvisible, props.css && props.css],
    tabIndex: props.onClick ? 0 : undefined,
    onClick: props.onClick,
    onKeyPress: handleOnKeyPress,
    className: className,
    ...props,
    children: props.children
  });
});
var _default = exports.default = Card;